export default __webpack_public_path__ + "static/media/google-plus.fa256cf5.png";